export default __webpack_public_path__ + "static/Multi-Language-Support-5044dbac4e788bd65f420ff2198e9e43.webp";